var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"dinamic_content"},[_c('transition',{attrs:{"name":_vm.tipoTransferencia}},[(_vm.paso==0)?_c('Index'):(_vm.paso==1)?_c('Stp'):(_vm.paso==-1)?_c('Login'):(_vm.paso==-2)?_c('ResetPass'):(_vm.paso==-3)?_c('ResetPass2'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }